import { api_url } from "@/app/api";
import { mapUrlToDomain } from "@/app/lib/utils";

const KNOWN_BACKEND_HOSTS = new Set([
   "productionapi.credible.social",
   "stagingapi.credible.social"
]);

export function toAuthenticatedFileUrl(value: string): string {
   try {
      const url = new URL(mapUrlToDomain(value));
      const configuredBackendHost = process.env.NEXT_PUBLIC_BACKEND_URL
         ? new URL(process.env.NEXT_PUBLIC_BACKEND_URL).host
         : "";
      if (url.host !== configuredBackendHost && !KNOWN_BACKEND_HOSTS.has(url.host)) {
         return value;
      }

      const uploadMarkerIndex = url.pathname.lastIndexOf("/uploads/");
      if (uploadMarkerIndex >= 0) {
         const storageKey = url.pathname.slice(uploadMarkerIndex + "/uploads/".length);
         if (!storageKey || storageKey.includes("/")) return value;

         return api_url.public_file_url.replace(
            "{storageKey}",
            encodeURIComponent(decodeURIComponent(storageKey))
         );
      }

      const fileMarkerIndex = url.pathname.lastIndexOf("/files/");
      if (fileMarkerIndex < 0) return value;

      const fileId = url.pathname.slice(fileMarkerIndex + "/files/".length);
      if (!/^[a-f\d]{24}$/i.test(fileId)) return value;

      return api_url.file_url.replace("{id}", encodeURIComponent(fileId));
   } catch {
      return value;
   }
}

export function toAbsoluteAuthenticatedFileUrl(value: string, origin: string): string {
   const authenticatedUrl = toAuthenticatedFileUrl(value);

   try {
      return new URL(authenticatedUrl, origin).toString();
   } catch {
      return authenticatedUrl;
   }
}
